<div class="noDataWrap">
  <div class="iconWrap">
      <i class="icon-no-data"></i>
  </div>
  <h2 class="subTitle">{{ title | transloco }}</h2>
  <p class="infoDesc">{{ description | transloco }}</p>
</div>